import React, { useState, useEffect } from "react";
import SelectComponent, { components } from "react-select";

import * as S from "./styles";
import { compact, filter, find, first, includes, map } from "lodash";

const styles = {
  control: (styles) => ({ ...styles, maxHeight: 76, overflow: "auto" }),
  loadingMessage: (styles) => ({ ...styles, fontFamily: "Roboto" }),
  option: (styles) => ({ ...styles, fontFamily: "Roboto" }),
  input: (styles) => ({
    ...styles,
    fontFamily: "Roboto",
    display: "flex",
    justifyContent: "center",
  }),
  menu: (styles) => ({ ...styles, fontFamily: "Roboto" }),
  placeholder: (styles) => ({ ...styles, fontFamily: "Roboto" }),
  singleValue: (styles) => ({ ...styles, fontFamily: "Roboto" }),
  multiValue: (styles) => ({
    ...styles,
    fontFamily: "Roboto",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    display: "flex",
    alignItems: "flex-start",
  }),
};

const SearchableMultipleSelect = ({
  getCustomLabel,
  entries,
  label,
  labelStyles,
  parser = (item) => item || {}, // should parse to {value: yourValue, label: yourLabel}
  placeholder,
  selectedOptions,
  setSelectedOptions, //function
  ...other
}) => {
  const [options, setOptions] = useState([]);
  const [key, setKey] = useState(new Date());

  useEffect(() => {
    // this is an workaround for selection clearing works
    setKey(new Date());
  }, [selectedOptions]);

  useEffect(() => {
    const parsed = compact(entries).map((entry) => ({
      ...parser(entry),
      rawEntry: entry,
    }));
    setOptions(parsed);
  }, [entries]);

  const onChange = (items) => {
    const selectedOptions = filter(
      options,
      (o) => find(items, (i) => i.value === o.value) != null
    );
    setSelectedOptions(map(selectedOptions, (it) => it.rawEntry));
  };

  const OptionComponent = (optionProps) => {
    const { data } = optionProps;
    if (getCustomLabel) {
      return (
        <components.Option {...optionProps}>
          {getCustomLabel(data.rawEntry)}
        </components.Option>
      );
    }
    return <components.Option {...optionProps}>{data.label}</components.Option>;
  };

  return (
    <>
      <S.Wrapper>
        <S.Main>
          {label && <S.Label {...labelStyles}>{label}</S.Label>}
          <SelectComponent
            {...other}
            key={key}
            components={{ Option: OptionComponent }}
            isMulti
            defaultValue={
              selectedOptions
                ? map(selectedOptions, (selected) => parser(selected))
                : null
            }
            isSearchable
            loadingMessage={() => "Carregando..."}
            name={label}
            noOptionsMessage={() => "Nenhum dado encontrado"}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            styles={styles}
          />
        </S.Main>
      </S.Wrapper>
    </>
  );
};

export default SearchableMultipleSelect;
